import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { User } from '../../types/types';
import Popup from '../Popup/Popup';
import { getDashboardUrlById } from '../../utils/common';
import { DataContext, UserContext } from '../../App';
import Button from '../Button/Button';
import { AppRoute, ButtonType } from '../../types/enums';

import done from './done.png';

import styles from './Onboarding.module.scss';

const Done = () => {
  const navigate = useNavigate();
  const { dashboards } = useContext(DataContext);
  const { setUser } = useContext(UserContext);

  const onJump = useCallback(() => {
    const url = getDashboardUrlById(dashboards[0]?.id);
    if (url) {
      window.open(url, '_blank')?.focus();
    }

    onAdmin();
  }, [dashboards]);

  const onAdmin = useCallback(() => {
    setUser((old) => ({ ...old, newlyRegistered: false } as User));
    navigate(AppRoute.WEBSITES);
  }, []);

  return (
    <Popup show permanent title="Congratulations!">
      <div className={styles.wrapper}>
        <p className={styles.intro}>
          Your <strong className="color-orange">Dashboard</strong> is ready. Check your{' '}
          <strong className="color-orange">Dashboard</strong> or jump to the{' '}
          <strong className="color-orange">Administration View</strong>.
        </p>
        <img src={done} alt="All set up!" />
        <div className={styles.buttons}>
          <Button action={onAdmin} spaceSaving type={ButtonType.GHOST}>
            Admin
          </Button>
          <Button action={onJump} spaceSaving type={ButtonType.PRIMARY}>
            Jump to dashboard
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default Done;
